import React, { useMemo } from "react";
import { makeStyles } from "tss-react/mui";

import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import List from "@mui/material/List";
import ListItemText from "@mui/material/ListItemText";
import ListItemButton from "@mui/material/ListItemButton";
import Collapse from "@mui/material/Collapse";

import { Virtuoso } from "react-virtuoso";

const useStyles = makeStyles()(() => ({
  ListItemText: {
    display: "flex",
    justifyContent: "space-between",
    gap: "10px",
  },
  CollapseList: {
    "& .MuiListItemButton-root": {
      padding: "2px 5px",
    },
    "& .MuiTypography-root": {
      fontSize: "14px",
    },
  },
  fieldType: {
    minWidth: "100px",
  },
}));

function CollapsibleVirtulizedList({
  currentMapping,
  name,
  fields,
  checkDisabled,
  handleSelect,
  isDefaultOpen,
  checkSelected,
  failedFields,
}) {
  const { classes } = useStyles();

  const { filedHeight, maxHeight, initialItemCount } = useMemo(() => {
    return {
      filedHeight: 33,
      maxHeight: 550,
      initialItemCount: 70,
    };
  }, []);

  return (
    <Collapse in={isDefaultOpen(name)} timeout="auto" unmountOnExit>
      <List component="div" disablePadding className={classes.CollapseList}>
        {fields.length > 0 ? (
          isDefaultOpen(name) && (
            <Virtuoso
              style={{
                height: `${
                  fields.length > 0
                    ? (fields.length * filedHeight > maxHeight ? maxHeight : fields.length * filedHeight) + 50
                    : 0
                }px`,
              }}
              totalCount={fields.length}
              data={fields}
              itemContent={(index, field) => {
                const type = field.type === "Reference" ? field.referenceFrom.field.type : field.type;
                const length = field.type === "Reference" ? field.referenceFrom.field.length : field.length;
                return (
                  <ListItemButton
                    selected={checkSelected(name, field.name)}
                    disabled={
                      (field.hasOwnProperty("isDeleted") && field.isDeleted.length > 0) ||
                      (!checkSelected(name, field.name) && checkDisabled(name, field.name, field.entity_mapping))
                    }
                    key={field.name}
                    sx={{ ml: 6, pl: 1 }}
                    onClick={(e) => handleSelect(name, field.name, type, length)}
                  >
                    <ListItemText
                      primary={
                        <Box className={classes.ListItemText}>
                          <Typography variant="body2">{field.name}</Typography>
                          <Typography variant="body2" className={classes.fieldType}>
                            {type} {length ? `(${length})` : ""}
                          </Typography>
                        </Box>
                      }
                      secondary={
                        checkSelected(name, field.name) &&
                        failedFields.some(
                          ({ dataSource, field: _field }) => field.name === _field && dataSource === name
                        ) ? (
                          <Typography color="error" fontSize="small">
                            {field.name} ({type}
                            {length ? ` - ${length}` : ""}) is not matching with {currentMapping.fieldName} (
                            {currentMapping.fieldType}{" "}
                            {currentMapping.fieldLength ? ` - ${currentMapping.fieldLength}` : ""})
                          </Typography>
                        ) : (
                          ""
                        )
                      }
                    />
                  </ListItemButton>
                );
              }}
              initialItemCount={fields.length > initialItemCount ? initialItemCount : fields.length}
            />
          )
        ) : (
          <ListItemText
            secondary={
              <Box className={classes.ListItemText}>
                <Typography variant="body2" sx={{ width: "100%", textAlign: "center" }}>
                  No attributes found
                </Typography>
              </Box>
            }
          />
        )}
      </List>
    </Collapse>
  );
}

export default React.memo(CollapsibleVirtulizedList);
